import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import CommonFooter from "../../core/common/footer/commonFooter";
import TooltipIcons from "../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import AddSales from "../../core/modals/purchases/addSales";
import { 
  useDeleteSalesOrderMutation, 
  useGetSalesOrderByIdQuery, 
  useGetSalesOrdersQuery,
  useUpdateSalesOrderMutation 
} from "../../core/redux/api/OrderApi";
import CommonDeleteModal from "../../core/common/modal/commonDeleteModal";
import toast from "react-hot-toast";
import EditSalesOrder from "../../core/modals/purchases/editSales";
import { DatePicker } from "antd";
import { useGetProductListQuery } from "../../core/redux/api/productApi";
import { useGetAllCustomerQuery } from "../../core/redux/api/userApi";
import { render } from "@fullcalendar/core/preact.js";

const SalesList = () => {
  const { data: todaySaleOrder, isLoading: isTodaySaleOrderLoading, refetch: refetchTodaySaleOrders } = useGetSalesOrdersQuery();
  const [deleteSale] = useDeleteSalesOrderMutation();
  const [updateSale, { isLoading: isUpdating }] = useUpdateSalesOrderMutation();
  const { data: productResponse } = useGetProductListQuery();
  console.log("productResponse", productResponse)
  const { data: customerResponse } = useGetAllCustomerQuery();
  
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [saleOrderToDelete, setSaleOrderToDelete] = useState(null);
  const [selectedSaleOrderId, setSelectedSaleOrderId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const { data: saleOrderData, isLoading: isSaleOrderLoading } = useGetSalesOrderByIdQuery(selectedSaleOrderId, {
    skip: !selectedSaleOrderId,
  });

  const handleDelete = async () => {
    if (!saleOrderToDelete) return;

    try {
      await toast.promise(
        deleteSale(saleOrderToDelete).unwrap(),
        {
          loading: 'Deleting order...',
          success: async () => {
            await refetchTodaySaleOrders();
            setShowDeleteModal(false);
            setSaleOrderToDelete(null);
            return 'Order deleted successfully!';
          },
          error: (err) => {
            if (err.status === 404) {
              refetchTodaySaleOrders();
              return 'Order was already removed';
            }
            return err.data?.message || 'Delete failed';
          }
        }
      );
    } catch (error) {
      console.error("Delete error:", error);
      const message = error?.data?.message || 'Delete failed';
      if (!message.includes("already deleted")) {
        toast.error(message);
      }
    }
  };

  const handleEdit = (record) => {
    setSelectedSaleOrderId(record._id);
    setShowEditModal(true);
  };

  const handleUpdateSalesOrder = async (values) => {
    try {
      await toast.promise(
        updateSale({
          _id: selectedSaleOrderId,
          ...values
        }).unwrap(),
        {
          loading: 'Updating order...',
          success: async () => {
            await refetchTodaySaleOrders();
            setShowEditModal(false);
            setSelectedSaleOrderId(null);
            return 'Order updated successfully!';
          },
          error: (err) => {
            return err.data?.message || 'Update failed';
          }
        }
      );
    } catch (error) {
      console.error("Update error:", error);
      toast.error(error?.data?.message || 'Update failed');
    }
  };

  const columns = [
    {
      title: "Sale Date",
      dataIndex: "saleDate",
      render: (date) => {
        const formattedDate = date ? new Date(date).toISOString().split('T')[0] : '-';
        return <span>{formattedDate}</span>;
      },
      sorter: (a, b) => new Date(a.saleDate || 0) - new Date(b.saleDate || 0),
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    
    {
      title: "Customer Name",
      dataIndex: "customer",
      render: (customer) => <span>{customer?.customerName}</span>,
      sorter: (a, b) => a.customer?.customerName.length - b.customer?.customerName.length,
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Product Name",
      dataIndex: "product",
      render: (product) => <span>{product?.productName}</span>,
      sorter: (a, b) => a.product?.productName.length - b.product?.productName.length,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },

    {
      title: "Quantity",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Unit",
      dataIndex: "unit",
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Sale Rate",
      dataIndex: "saleRate",
      sorter: (a, b) => a.saleRate - b.saleRate,
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
    {
      title: "Note",
      dataIndex: "note",
      render: (text) => text || "-",
      responsive: ['sm', 'md', 'lg', 'xl'],
    },
  {
  title: "Amount",
  dataIndex: "totalAmount",
  key: "totalAmount", 
  render: (val) => {
    if (val === null || val === undefined) return 'N/A';
    return '₹' + Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  sorter: (a, b) => a.totalAmount - b.totalAmount,
  responsive: ['sm', 'md', 'lg', 'xl'],
},
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleEdit(record);
              }}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link
              to="#"
              className="p-2"
                 data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={(e) => {
                e.preventDefault();
                setSaleOrderToDelete(record._id);
      
              }}
            >
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
  ];

  const expandable = {
    expandedRowRender: (record) => (
      <div>
         <p><strong>Product Name:</strong> {record.product.productName}</p>
         <p><strong>Customer Name:</strong> {record.customer.customerName}</p>
         <p><strong>Sale Date:</strong> {record.saleDate}</p>
        <p><strong>Quantity:</strong> {record.quantity}</p>
        <p><strong>Unit:</strong> {record.unit}</p>
        <p><strong>Sale Rate:</strong> {record.saleRate}</p>
        <p><strong>Note:</strong> {record.note || "-"}</p>
        <p><strong>Amount:</strong> {record.totalAmount}</p>
      </div>
    ),
    rowExpandable: () => true,
  };

  const excelOptions = {
  fileName: 'Product_Issued',
  sheetName: 'Issued',
  columns: [
    { key: 'saleDate', header: 'Sale Date' },
    { key: 'customerName', header: 'Customer' },
    { key: 'productName', header: 'Product' },
    { key: 'quantity', header: 'Quantity' },
    { key: 'saleRate', header: 'Sale Rate' },
    { key: 'amount', header: 'Amount' }
  ],
  data: todaySaleOrder?.map(receipt => ({
    saleDate: new Date(receipt.saleDate).toLocaleDateString(),
    customerName: receipt.customer?.customerName,
    productName: receipt.product?.productName,
    quantity: receipt.quantity,
    saleRate: receipt.saleRate,
    amount: receipt.totalAmount // Changed from amount to totalAmount to match your column
  })) || []
};

const pdfOptions = {
  fileName: 'Product_Issued',
  title: 'Product Issued List',
  columns: [
    { key: 'saleDate', header: 'Sale Date' },
    { key: 'customerName', header: 'Customer' },
    { key: 'productName', header: 'Product' },
    { key: 'quantity', header: 'Quantity' },
    { key: 'saleRate', header: 'Sale Rate' },
    { key: 'amount', header: 'Amount' }
  ],
  data: todaySaleOrder?.map(receipt => ({
    saleDate: new Date(receipt.saleDate).toLocaleDateString(),
    customerName: receipt.customer?.customerName,
    productName: receipt.product?.productName,
    quantity: receipt.quantity,
    saleRate: receipt.saleRate,
    amount: receipt.totalAmount // Changed from amount to totalAmount to match your column
  })) || [],
  fileNamePrefix: 'Issued'
};
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Sales</h4>
                <h6>Manage Your Sale Order</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons excelOptions={excelOptions} pdfOptions={pdfOptions}/>
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <i className='ti ti-circle-plus me-1'></i>
                Add Sales
              </Link>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              {/* <div className="search-set"></div> */}
              {/* <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Payment Status
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li><Link to="#" className="dropdown-item rounded-1">Paid</Link></li>
                    <li><Link to="#" className="dropdown-item rounded-1">Unpaid</Link></li>
                    <li><Link to="#" className="dropdown-item rounded-1">Overdue</Link></li>
                  </ul>
                </div>
              </div> */}
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <Table 
                  columns={columns} 
                  dataSource={todaySaleOrder} 
                  expandable={expandable} 
                  loading={isTodaySaleOrderLoading}
                />
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      <AddSales 
        productResponse={productResponse}
        customerResponse={customerResponse}
      />
      
      {showEditModal && (
        <EditSalesOrder
          salesOrder={saleOrderData}
          productlist={productResponse?.data}
          customersList={customerResponse}
          onUpdate={handleUpdateSalesOrder}
          onCancel={() => {
            setShowEditModal(false);
            setSelectedSaleOrderId(null);
          }}
          isUpdating={isUpdating}
          isLoading={isSaleOrderLoading}
        />
      )}

      <CommonDeleteModal 
      handleDelete={handleDelete}
         />
    </div>
  );
};

export default SalesList;